import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export const updatescanccodepointsrule = option =>
  request3('v1/points/rule/updatescanccodepointsrule', option, true, false) // 编辑商品积分

export const addscanccodepointsrule = option =>
  request3('v1/points/rule/addscanccodepointsrule', option, true, false) // 新增商品积分

export const addscanccodepointsrules = option =>
  request3('v1/points/rule/addscanccodepointsrules', option, true, false) // 批量新增扫码送积分规则

export const openscanccodepointsrule = option => {
  const urls = urlStringify(option)
  return request3(
    'v1/points/rule/openscanccodepointsrule' + urls,
    {},
    true,
    false
  )
} // 启用扫码送积分规则

export const closescanccodepointsrule = option => {
  const urls = urlStringify(option)
  return request3(
    'v1/points/rule/closescanccodepointsrule' + urls,
    {},
    true,
    false
  )
} // 停用扫码送积分规则

export const deletescanccodepointsrule = option => {
  const urls = urlStringify(option)
  return request3(
    'v1/points/rule/deletescanccodepointsrule' + urls,
    {},
    true,
    false
  )
} // 删除商品积分

export const getnoscanccodepointsruleproductnames = option =>
  request3(
    'v1/points/rule/getnoscanccodepointsruleproductnames',
    option,
    true,
    false
  ) // 获取积分商品名称列表

export const getscanccodepointsrules = option =>
  request3('v1/points/rule/getscanccodepointsrules', option, true, false) // 获取积分商品列表

export const getgoodslist = option =>
  request3('v1/points/exchangegoods/getgoodslist', option, true, false) // 获取积分商城商品列表

export const getnoruleproductnames = option =>
  request3(
    'v1/points/exchangeproduct/getnoruleproductnames',
    option,
    true,
    false
  ) // 获取新增商品下拉商品名称

export const addrule = option =>
  request3('v1/points/exchangeproduct/addrule', option, true, false) // 新增积分规则

export const updaterule = option =>
  request3('v1/points/exchangeproduct/updaterule', option, true, false) // 编辑积分规则

export const deleterule = option => {
  const urls = urlStringify(option)
  return request3('v1/points/exchangeproduct/deleterule' + urls, {}, true, false) // 删除积分规则
}

export const getpointsexchangeprodrecords = option =>
  request3(
    'v1/points/exchangeproduct/getpointsexchangeprodrecords',
    option,
    true,
    false
  ) // 兑换记录列表

export const cancelproduct = option =>
  request3('v1/points/exchangeproduct/cancelproduct', option, true, false) // 核销商品积分

export const getrulelist = option =>
  request3('v1/points/rule/getrules', option, true, false) // 查询积分获取规则列表

export const closerule = option => {
  const urls = urlStringify(option)
  return request3('v1/points/rule/closerule' + urls, {}, true, false) // 关闭积分获取规则
}

export const openrule = option => {
  const urls = urlStringify(option)
  return request3('v1/points/rule/openrule' + urls, {}, true, false) // 打开积分获取规则
}
export const getrule = option => {
  const urls = urlStringify(option)
  return request3('v1/points/dailycheckin/getrule' + urls, {}, true, false) // 查询签到送积分规则
}

export const adddailycheckin = option =>
  request3('v1/points/dailycheckin/addrule', option, true, false) // 新增签到积分

export const updatedailycheckin = option =>
  request3('v1/points/dailycheckin/updaterule', option, true, false) // 修改签到积分

export const addgoods = option =>
  request3('v1/points/exchangegoods/addgoods', option, true, false) // 新增积分兑换物品

export const upshelfgoods = option => {
  const urls = urlStringify(option)
  return request3('v1/points/exchangegoods/upshelfgoods' + urls, {}, true, false) // 兑换物品上架
}

export const downshelfgoods = option => {
  const urls = urlStringify(option)
  return request3(
    'v1/points/exchangegoods/downshelfgoods' + urls,
    {},
    true,
    false
  ) // 兑换物品下架
}

export const deletegoods = option => {
  const urls = urlStringify(option)
  return request3('v1/points/exchangegoods/deletegoods' + urls, {}, true, false) // 删除兑换物品
}

export const getgoods = option => {
  const urls = urlStringify(option)
  return request3('v1/points/exchangegoods/getgoods' + urls, {}, true, false) // 查询兑换物品
}

export const updategoods = option =>
  request3('v1/points/exchangegoods/updategoods', option, true, false) // 修改兑换物品

export const updatepointstask = option =>
  request3('v1/points/rule/updatepointstask', option, true, false) // 修改积分任务

export const getpointstask = option => {
  const urls = urlStringify(option)
  return request3('v1/points/rule/getpointstask' + urls, {}, true, false) // 查询积分任务
}

export default {
  // 查询积分获取规则列表
  getrulelist: option => request3('v1/points/rule/getrules', option, true),
  // 关闭积分获取规则
  closerule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/rule/closerule' + urls, {}, true)
  },
  // 打开积分获取规则
  openrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/rule/openrule' + urls, {}, true)
  },
  // 查询签到送积分规则
  getrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/dailycheckin/getrule' + urls, {}, true)
  },
  // 新增签到积分
  adddailycheckin: option =>
    request3('v1/points/dailycheckin/addrule', option, true),
  // 修改签到积分
  updatedailycheckin: option =>
    request3('v1/points/dailycheckin/updaterule', option, true),
  // 修改积分任务
  updatepointstask: option =>
    request3('v1/points/rule/updatepointstask', option, true),
  // 查询积分任务
  getpointstask: option => {
    const urls = urlStringify(option)
    return request3('v1/points/rule/getpointstask' + urls, {}, true)
  },
  // 编辑商品积分
  updatescanccodepointsrule: option =>
    request3('v1/points/rule/updatescanccodepointsrule', option, true),
  // 批量新增扫码送积分规则
  addscanccodepointsrules: option =>
    request3('v1/points/rule/addscanccodepointsrules', option, true),
  // 删除商品积分
  deletescanccodepointsrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/rule/deletescanccodepointsrule' + urls, {}, true)
  },
  // 获取积分商品名称列表
  getnoscanccodepointsruleproductnames: option => {
    const url = 'v1/points/rule/getnoscanccodepointsruleproductnames'
    return request3(url, option, true)
  },
  // 获取积分商品列表
  getscanccodepointsrules: option =>
    request3('v1/points/rule/getscanccodepointsrules', option, true, false),
  // 停用扫码送积分规则
  closescanccodepointsrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/rule/closescanccodepointsrule' + urls, {}, true)
  },
  // 启用扫码送积分规则
  openscanccodepointsrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/rule/openscanccodepointsrule' + urls, {}, true)
  },
  // 修改支付送积分规则
  updatepayrule: option =>
    request3('v1/points/paygiverule/updaterule', option, true),
  // 批量新增支付送积分规则
  addpayrules: option =>
    request3('v1/points/paygiverule/addrules', option, true),
  // 删除支付送积分规则
  delpayrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/paygiverule/delrule' + urls, {}, true)
  },
  // 查询未设置支付
  getnotsetedgoodslist: option => {
    const url = 'v1/points/paygiverule/getnotsetedgoodslist '
    return request3(url, option, true)
  },
  // 查询支付送积分列表
  getpayrules: option =>
    request3('v1/points/paygiverule/getrules', option, true, false),
  // 停用支付送积分规则
  closepayrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/paygiverule/closerule' + urls, {}, true)
  },
  // 启用支付送积分规则
  openpayrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/paygiverule/openrule' + urls, {}, true)
  },
  // 查询线下扫码送积分规则列表
  getofflineactivityrules: option =>
    request3('v1/points/rule/getofflineactivityrules', option, true, false),
  // 查询线下扫码送积分规则
  getofflineactivityrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/rule/getofflineactivityrule' + urls, {}, true)
  },
  // 修改线下扫码活动积
  updateofflineactivityrule: option =>
    request3('v1/points/rule/updateofflineactivityrule', option, true),
  // 新增线下扫码活动积分规则
  addofflineactivityrule: option =>
    request3('v1/points/rule/addofflineactivityrule', option, true),
  // 删除线下扫码送积分
  deleteofflineactivityrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/rule/deleteofflineactivityrule' + urls, {}, true)
  },
  // 关闭线下扫码送积分
  closeofflineactivityrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/rule/closeofflineactivityrule' + urls, {}, true)
  },
  // 启用线下扫码送积分
  openofflineactivityrule: option => {
    const urls = urlStringify(option)
    return request3('v1/points/rule/openofflineactivityrule' + urls, {}, true)
  }
}
